import { useContext } from 'react';
import { AuthContext } from '../module/AuthenticationModule';

export const useAuth = () => {
    const { isSignedIn, tokenExists, user_id, token } = useContext(AuthContext);
    return { isSignedIn, tokenExists, user_id, token };
};
